import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-biz-flex-loan-callback.component.scss';
var FormItemBizFlexLoanCallback = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBizFlexLoanCallback, _super);
    function FormItemBizFlexLoanCallback(element) {
        return _super.call(this, element) || this;
    }
    FormItemBizFlexLoanCallback.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-biz-flex-call-me-back_button');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemBizFlexLoanCallback.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select, textarea');
            _this.validationService.validate(formFields);
            _this.validateIdentityTypeSelection();
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
        // toggle id/coreg fields
        if (this.form) {
            this.form.querySelectorAll("input[name=identification-type]").forEach(function (radio) {
                radio.addEventListener("change", function () {
                    _this.toggleIdOrCoregViewInputs();
                }, false);
            });
        }
        // customise fields
        this.customizeFields();
        // set view state
        this.toggleIdOrCoregViewInputs();
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector("input[name=coregNum]");
        if (businessReg) {
            businessReg.addEventListener("input", function (pEvent) {
                if ((pEvent.inputType !== "deleteContentBackward") && (pEvent.inputType !== "deleteContentForward")) {
                    var reg = pEvent.target.value;
                    pEvent.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (pEvent) {
                var reg = pEvent.target.value;
                pEvent.target.value = _this.validationService.formatExpression(reg);
            });
        }
    };
    FormItemBizFlexLoanCallback.prototype.submitForm = function (pForm) {
        var _this = this;
        // variables
        var kindOfHelp = pForm.querySelector("select[name=kindOfHelp]");
        var firstName = pForm.querySelector("input[name=firstName]");
        var lastName = pForm.querySelector("input[name=lastName]");
        var businessName = pForm.querySelector("input[name=businessName]");
        var saIDNumber = pForm.querySelector("input[name=idNumber]");
        var coregNumber = pForm.querySelector("input[name=coregNum]");
        var phoneNumber = pForm.querySelector("input[name=phoneNumber]");
        var date = pForm.querySelector("input[name=date]");
        var time = pForm.querySelector("select[name=time]");
        // extra fields
        var recipient = pForm.querySelector("input[name=recipient]");
        var toEmail = pForm.querySelector("input[name=email]");
        var subject = pForm.querySelector("input[name=subject]");
        var _dateTime = "";
        if (date.value) {
            _dateTime += date.value;
        }
        if (_dateTime) {
            _dateTime += " " + (time.value + "").toLowerCase();
        }
        else {
            _dateTime += (time.value + "").toLowerCase();
        }
        var _postData = {
            'kindOfHelp': (kindOfHelp.selectedIndex > 0 ? kindOfHelp.options[kindOfHelp.selectedIndex].value : ""),
            'firstName': (firstName ? firstName.value : ""),
            'lastName': (lastName ? lastName.value : ""),
            'businessName': (businessName ? businessName.value : ""),
            'saID': (saIDNumber ? saIDNumber.value : ""),
            'busReg': (coregNumber ? coregNumber.value : ""),
            'phoneNumber': (phoneNumber ? phoneNumber.value : ""),
            'callDateTime': _dateTime,
            'recipient': (recipient ? recipient.value : ""),
            'email': (toEmail ? toEmail.value : ""),
            'subject': (subject ? subject.value : ""),
            'source': this.formsService.isMobile()
        };
        /*Code End*/
        this.showDisplayView("loader");
        var url = this.baseUrl + "/services/genericform.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function () {
            _this.analyticsService.dtmFormComplete("complete", '200');
            var name = _this.form.querySelector(".form__success-container__firstname");
            name.innerHTML = firstName.value;
            _this.showDisplayView("success");
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBizFlexLoanCallback.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    FormItemBizFlexLoanCallback.prototype.customizeFields = function () {
        var field = this.form.querySelector("input[name=firstName]");
        field.setAttribute("maxlength", "50");
        field = this.form.querySelector("input[name=lastName]");
        field.setAttribute("maxlength", "50");
        field = this.form.querySelector("input[name=businessName]");
        field.setAttribute("maxlength", "50");
        field = this.form.querySelector("input[name=coregNum]");
        field.setAttribute("maxlength", "25");
    };
    FormItemBizFlexLoanCallback.prototype.toggleIdOrCoregViewInputs = function () {
        var _this = this;
        var isCheckedExist = false;
        this.form.querySelectorAll("input[name=identification-type]").forEach(function (radio) {
            if (radio.checked) {
                isCheckedExist = true;
                if (radio.value === "said") {
                    _this.element.querySelector(".form-item-bizflex-loan__coreg").classList.add('form__group--hidden');
                    _this.element.querySelector(".form-item-bizflex-loan__identification").classList.remove('form__group--hidden');
                    _this.reinitializeField(_this.form.querySelector("input[name=coregNum]"));
                }
                else {
                    _this.element.querySelector(".form-item-bizflex-loan__identification").classList.add('form__group--hidden');
                    _this.element.querySelector(".form-item-bizflex-loan__coreg").classList.remove('form__group--hidden');
                    _this.reinitializeField(_this.form.querySelector("input[name=idNumber]"));
                }
            }
        });
    };
    FormItemBizFlexLoanCallback.prototype.getIdentityType = function () {
        var isCheckedExist = false;
        var idType = "";
        this.form.querySelectorAll("input[name=identification-type]").forEach(function (radio) {
            if (radio.checked) {
                isCheckedExist = true;
                idType = radio.value;
            }
        });
        return idType;
    };
    FormItemBizFlexLoanCallback.prototype.validateIdentityTypeSelection = function () {
        var requiredMessage = "This field is required";
        if (!this.getIdentityType()) {
            var wrapperDiv = this.form.querySelector(".form-item-bizflex-loan__identification_select");
            wrapperDiv.classList.add("form__group--error");
            var _errorDiv = document.createElement("div");
            _errorDiv.classList.add("form__group--error_message");
            var _errors = document.createElement("ul");
            _errorDiv = document.createElement("div");
            _errorDiv.classList.add("form__group--error_message");
            var _error = document.createElement("li");
            _error.innerHTML = requiredMessage;
            _errors.appendChild(_error);
            _errorDiv.appendChild(_errors);
            wrapperDiv.appendChild(_errorDiv);
        }
    };
    FormItemBizFlexLoanCallback.prototype.reinitializeField = function (field) {
        var element = field.closest('.form__group');
        element.classList.remove('form__group--error');
        var errorMessage = element.querySelector(".form__group--error_message");
        if (errorMessage) {
            errorMessage.remove();
        }
        field.value = "";
    };
    return FormItemBizFlexLoanCallback;
}(Base));
export { FormItemBizFlexLoanCallback };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-biz-flex-loan-callback/form-item-biz-flex-loan-callback.component.ts
// module id = 820
// module chunks = 0